import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Flame, Home, Leaf, Sparkles } from 'lucide-react';
import { Card, CardContent } from './ui/card';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const iconMap = {
  Flame: Flame,
  Home: Home,
  Leaf: Leaf,
  Sparkles: Sparkles
};

export const Benefits = () => {
  const [content, setContent] = useState(null);

  useEffect(() => {
    fetchContent();
  }, []);

  const fetchContent = async () => {
    try {
      const response = await axios.get(`${API}/homepage`);
      setContent(response.data.content);
    } catch (error) {
      console.error('Error fetching homepage content:', error);
    }
  };

  if (!content) {
    return null;
  }

  return (
    <section id="benefits" className="py-12 bg-gradient-to-br from-gray-50 via-white to-amber-50/30">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-10">
          <h2 className="text-3xl md:text-4xl font-bold mb-3">
            <span className="bg-gradient-to-r from-gray-900 to-amber-800 bg-clip-text text-transparent">
              {content.benefitsTitle}
            </span>
          </h2>
          <p className="text-base text-gray-600 max-w-2xl mx-auto">
            {content.benefitsSubtitle}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {content.benefits.map((benefit, index) => {
            const Icon = iconMap[benefit.icon] || Sparkles;
            return (
              <Card
                key={index}
                className="group border-0 shadow-md hover:shadow-xl transition-all duration-500 bg-white/80 backdrop-blur-sm hover:-translate-y-2"
              >
                <CardContent className="p-8 text-center">
                  <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-amber-100 to-amber-200 mb-6 group-hover:scale-110 transition-transform duration-500">
                    <Icon className="w-8 h-8 text-amber-700" />
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-3">
                    {benefit.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {benefit.description}
                  </p>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Additional selling points */}
        <div className="mt-10 bg-white rounded-2xl shadow-xl p-6 md:p-8">
          <div className="grid md:grid-cols-2 gap-8 items-center">
            <div>
              <h3 className="text-2xl font-bold text-gray-900 mb-4">
                {content.benefitsExtraTitle}
              </h3>
              <div className="space-y-3">
                {content.benefitsExtraPoints && content.benefitsExtraPoints.map((point, index) => (
                  <div key={index} className="flex items-start gap-3">
                    <div className="w-2 h-2 bg-amber-600 rounded-full mt-2"></div>
                    <p className="text-gray-700 text-sm">
                      {point}
                    </p>
                  </div>
                ))}
              </div>
            </div>
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-br from-amber-200 to-gray-200 rounded-2xl blur-2xl opacity-30"></div>
              <img
                src={content.benefitsImageUrl}
                alt="Biocamino elegante"
                className="relative rounded-2xl shadow-2xl w-full h-auto"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};